import { render } from "./FooterTile.vue?vue&type=template&id=5dd63a10&scoped=true"
import script from "./FooterTile.vue?vue&type=script&lang=js"
export * from "./FooterTile.vue?vue&type=script&lang=js"

import "./FooterTile.vue?vue&type=style&index=0&id=5dd63a10&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd63a10"]])

export default __exports__